import {WinPrizeTypeVo} from '../../common/shared/api/nicolas/vo/enums/WinPrizeTypeVo.enum';
import {WinPrizeType} from '../generated/types';

export function createWinPrizeType(winPrizeType: WinPrizeTypeVo): WinPrizeType {
  return mapper[winPrizeType];
}

const mapper: {[key in WinPrizeTypeVo]: WinPrizeType} = {
  [WinPrizeTypeVo.Cash]: WinPrizeType.Cash,
  [WinPrizeTypeVo.Goods]: WinPrizeType.Goods,
  [WinPrizeTypeVo.Ticket]: WinPrizeType.Ticket,
};
